webpackJsonp([6740024304140],{

/***/ 212:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyImage = __webpack_require__(18);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _gatsbyLink = __webpack_require__(25);
	
	var _reactMedia = __webpack_require__(21);
	
	var _reactMedia2 = _interopRequireDefault(_reactMedia);
	
	__webpack_require__(343);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BlogPostCard = function BlogPostCard(props) {
	  var blogPost = props.blogPost.node;
	  var transformedPost = blogPost.childContentfulBlogPostPostTextNode.childMarkdownRemark;
	  var heroPhoto = blogPost.heroPhoto;
	  var date = blogPost.date;
	  var excerpt = transformedPost.excerpt;
	  var timeToRead = transformedPost.timeToRead;
	
	  return _react2.default.createElement(
	    'div',
	    {
	      onClick: function onClick() {
	        return (0, _gatsbyLink.navigateTo)('/' + blogPost.node_locale + '/blog/' + blogPost.slug);
	      },
	      className: 'blog-post-card'
	    },
	    _react2.default.createElement(
	      _reactMedia2.default,
	      { query: { minWidth: '768px' } },
	      function (matches) {
	        return matches ?
	        // si plus grand que 768px =>
	        _react2.default.createElement(_gatsbyImage2.default, {
	          className: 'blog-post-card-img',
	          alt: heroPhoto.title,
	          sizes: _extends({}, heroPhoto.sizes, { aspectRatio: 930 / 300 })
	        }) : _react2.default.createElement(_gatsbyImage2.default, {
	          className: 'blog-post-card-img',
	          alt: heroPhoto.title,
	          sizes: heroPhoto.sizes
	        });
	      }
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'blog-post-card-content container-fluid' },
	      _react2.default.createElement(
	        'div',
	        { className: 'text-muted' },
	        date,
	        ' - ',
	        timeToRead,
	        ' ',
	        props.timeToRead
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'blog-post-card-title' },
	        blogPost.title
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'blog-post-card-excerpt' },
	        excerpt
	      )
	    )
	  );
	};
	
	BlogPostCard.propTypes = {
	  blogPost: _propTypes2.default.object.isRequired,
	  timeToRead: _propTypes2.default.string
	};
	
	exports.default = BlogPostCard;
	module.exports = exports['default'];

/***/ }),

/***/ 343:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 229:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(36);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	__webpack_require__(351);
	
	var _BlogPostCard = __webpack_require__(212);
	
	var _BlogPostCard2 = _interopRequireDefault(_BlogPostCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Blog = function Blog(props) {
	  var blogPageContent = props.blogPageContent,
	      blogPosts = props.blogPosts;
	
	
	  var hreflang = blogPageContent.node.node_locale === 'fr' ? 'en' : 'fr';
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'blog' },
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement('html', { lang: blogPageContent.node.node_locale }),
	      _react2.default.createElement(
	        'title',
	        null,
	        blogPageContent.node.title
	      ),
	      _react2.default.createElement('meta', { name: 'description', content: blogPageContent.node.description }),
	      _react2.default.createElement('link', {
	        rel: 'alternate',
	        hreflang: hreflang,
	        href: 'https://www.offshoreservices.fr/' + hreflang + '/blog/'
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'blog-title' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          'BLOG'
	        ),
	        _react2.default.createElement(
	          'h2',
	          null,
	          blogPageContent.node.subTitle
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'blog-posts' },
	          blogPosts && blogPosts.map(function (blogPost, i) {
	            return _react2.default.createElement(_BlogPostCard2.default, {
	              key: i,
	              blogPost: blogPost,
	              timeToRead: blogPageContent.node.timeToRead
	            });
	          })
	        )
	      )
	    )
	  );
	};
	
	Blog.propTypes = {
	  blogPageContent: _propTypes2.default.object,
	  blogPosts: _propTypes2.default.array
	};
	
	exports.default = Blog;
	module.exports = exports['default'];

/***/ }),

/***/ 351:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 600:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.enBlogQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Blog = __webpack_require__(229);
	
	var _Blog2 = _interopRequireDefault(_Blog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BlogPage = function BlogPage(props) {
	  var blogPosts = props.data.allContentfulBlogPost.edges;
	  var blogPageContent = props.data.allContentfulBlog.edges[0];
	  return _react2.default.createElement(_Blog2.default, { blogPageContent: blogPageContent, blogPosts: blogPosts });
	};
	
	BlogPage.propTypes = {
	  data: _propTypes2.default.object
	};
	
	exports.default = BlogPage;
	var enBlogQuery = exports.enBlogQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-blog-en-js-e16e6911ed46063a1ff3.js